import axiosHttp from "services/axiosHttp";
import { REWARD_BASE_URL } from "configs/AppConfig";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { message } from "antd";

// Action for fetching inventory summary from the new endpoint
export const fetchInventoryUpload = createAsyncThunk(
  "fetchInventoryUpload",
  async ({ channel_id,file }, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("file", file);
      const response = await axiosHttp.post(`${REWARD_BASE_URL}backoffice/channel/${channel_id}/stock/upload`,formData);
      message.success("Inventory uploaded successfully!");
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Something went wrong");
    }
  }
);

const RewardInventoryUploadlice = createSlice({
  name: "RewardInventoryUploadlice",
  initialState: {
    isLoading: false,
    data: null,
    error: null,
  },

  reducers: {
		resetRewardInventoryUploadlice: (state) => {
			state.isLoading = false;
			state.isError = false;
			state.error = null;
			state.data = null;
		},
	},

  extraReducers: (builder) => {
    builder.addCase(fetchInventoryUpload.pending, (state) => {
      state.isLoading = true;
      state.error = null; // Clear any previous error on new request
    });

    builder.addCase(fetchInventoryUpload.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload; // Adjust based on response structure
    });

    builder.addCase(fetchInventoryUpload.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload || "Unknown error occurred";
    });
  },
});


export default RewardInventoryUploadlice.reducer;
export const { resetRewardInventoryUploadlice } = RewardInventoryUploadlice.actions;
